// External deps
import { useContext } from 'react';

// Internal deps
import { LoadingContext } from '../context/LoadingProvider';

export default function useLoading() {
  return useContext(LoadingContext);
}
